module.exports = __webpack_public_path__ + "img/layout-third.71e27010.svg";